import SET_MODAL_OVERLAY_VISIBILITY from './mutations';

export default {
  namespaced: true,
  state() {
    return {
      showModal: {},
    };
  },
  mutations: {
    [SET_MODAL_OVERLAY_VISIBILITY](state, id) {
      state.showModal[id] = !state.showModal[id];
    },
  },
};
